export const SV: Record<string, string> = {
  "Home": "Hem",
  "Resource Selected": "Vald Resurs",
  "Resources List": "Resurslista",
  "List": "Lista",
  "Resources": "Resurser",
  "Find Colleague": "Hitta Kollega",
  "Settings": "Inställningar",
  "Floor Plan": "Golvvägg",
  "Locations": "Platser",
  "Categories": "Kategorier",
  "Search resource name...": "Sök resursnamn...",
  "Calendar": "Kalender",
  "View Details": "Visa Detaljer",
  "Add to My Favorites": "Lägg till i Mina Favoriter",
  "Remove": "Ta bort",
  "Resource calendar": "Resurskalender",
  "Today": "Idag",
  "Previous month": "Föregående månad",
  "Next month": "Nästa månad",
  "Previous year": "Föregående år",
  "Next year": "Nästa år",
  "Close": "Stäng",
  "Field is required.": "Fält krävs.",
  "Invalid date format.": "Ogiltigt datumformat.",
  "S": "Sön",
  "M": "Mån",
  "T": "Tis",
  "W": "Ons",
  "F": "Fre",
  "January": "Januari",
  "February": "Februari",
  "March": "Mars",
  "April": "April",
  "May": "Maj",
  "June": "Juni",
  "July": "Juli",
  "August": "Augusti",
  "September": "September",
  "October": "Oktober",
  "November": "November",
  "December": "December",
  "Jan": "Jan",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Apr",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Aug",
  "Sep": "Sep",
  "Oct": "Okt",
  "Nov": "Nov",
  "Dec": "Dec",
  "st": "a",
  "nd": "a",
  "rd": "e",
  "th": "e",
  "Sunday": "Söndag",
  "Monday": "Måndag",
  "Tuesday": "Tisdag",
  "Wednesday": "Onsdag",
  "Thursday": "Torsdag",
  "Friday": "Fredag",
  "Saturday": "Lördag",
  "Sun": "Sön",
  "Mon": "Mån",
  "Tue": "Tis",
  "Wed": "Ons",
  "Thu": "Tor",
  "Fri": "Fre",
  "Sat": "Lör",
  "Su": "Sön",
  "Mo": "Mån",
  "Tu": "Tis",
  "We": "Ons",
  "Th": "Tor",
  "Fr": "Fre",
  "Sa": "Lör",
  "PM": "EM",
  "AM": "FM",
  "You cannot book this resource because your meeting request conflicts with the resource's booking policies.":
    "Du kan inte boka denna resurs eftersom din mötesförfrågan krockar med resursens bokningsregler.",
  "You need permissions to interact with this resource.":
    "Du behöver behörighet för att interagera med denna resurs.",
  "Reason": "Anledning",
  "The resource cannot be booked {{day}} days in advanced.":
    "Resursen kan inte bokas {{day}} dagar i förväg.",
  "The end date of a recurring meeting cannot be more than {{day}} days from today.":
    "Slutdatumet för ett återkommande möte kan inte vara mer än {{day}} dagar från idag.",
  "Meeting duration cannot be longer than {{time}} minutes long.":
    "Mötestiden får inte vara längre än {{time}} minuter.",
  "Meeting duration cannot be shorter than {{time}} minutes long.":
    "Mötestiden får inte vara kortare än {{time}} minuter.",
  "Booking policy": "Bokningspolicy",
  "Available": "Tillgänglig",
  "Selected": "Vald",
  "Booked": "Bokad",
  "Closed": "Stängd",
  "Filter Options": "Filteralternativ",
  "{{resource}} is deleted": "{{resource}} är raderad.",
  "This resource can be booked but any occurrences with conflicts the resource will not be booked.":
    "Denna resurs kan bokas, men eventuella konflikter med resursen kommer inte att bokas.",
  "This resource can be booked in advance for a maximum of {{day}} days, any occurrences beyond that limit will not be booked":
    "Denna resurs kan bokas i förväg i högst {{day}} dagar, eventuella förekomster utöver den gränsen kommer inte att bokas",
  "This resource can be booked, but the meeting duration must be at least {{time}} minutes.":
    "Denna resurs kan bokas, men mötestiden måste vara minst {{time}} minuter.",
  "This resource can be booked, but the meeting duration must not exceed {{time}} minutes.":
    "Denna resurs kan bokas, men mötestiden får inte överstiga {{time}} minuter.",
  "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.":
    "För att boka denna resurs krävs godkännande av resursens ombud. Din begäran kommer att vidarebefordras i väntan på godkännande.",
  "Resource Name": "Resursnamn",
  "Description": "Beskrivning",
  "Resource Mail": "Resursens e-post",
  "Location": "Plats",
  "Capacity": "Kapacitet",
  "Language": "Språk",
  "Select an language": "Välj ett språk",
  "Date/Time Format": "Datum/Tidsformat",
  "First day of the week": "Första dagen i veckan",
  "Please select a first day": "Vänligen välj en första dag",
  "Please select a time format": "Vänligen välj ett tidsformat",
  "Date Format": "Datumformat",
  "Please select a date format": "Vänligen välj ett datumformat",
  "Date Separator": "Datumseparator",
  "Please select a date separator": "Vänligen välj en datumseparator",
  "Apply": "Tillämpa",
  "Default Location": "Standardplats",
  "Clear": "Rensa",
  "Help": "Hjälp",
  "Unavailable": "Ej tillgänglig",
      "No data available": "Inga tillgängliga data",
      "More": "Mer",
  "Available Floor Plans": "Tillgängliga golvvägg",
  "Default Categories": "Standardkategorier",
  "List more Resources": "Lista fler resurser",
  "Attendees": "Deltagare",
  "Click on Further information to visit our support site": "Klicka på Mer information för att besöka vår supportsida",
  "New Order": "Ny Beställning",
  "Save default categories successfully": "Spara standardkategorier framgångsrikt",
      "Save config date/time successfully": "Spara konfigurationsdatum/tid framgångsrikt",
      "Save language successfully": "Spara språk framgångsrikt",
      "Save default location successfully": "Spara standardplats framgångsrikt",
      "And": "Och",
  "Or": "Eller",
  "Available occurrences of the series": "Tillgängliga förekomster av serien",
  "Conflicting Occurrences": "Konfliktande förekomster",
  "Availability": "Tillgänglighet",
  "Time Format": "Tidsformat",
  "You do not have permission to book this resource.": "Du har inte behörighet att boka den här resursen.",
"This resource does not allow booking of recurring meetings.": "Denna resurs tillåter inte bokning av återkommande möten.",
"You cannot book this resource.": "Du kan inte boka den här resursen."
};
